import React from "react";
import "./Counter.css";

const Counter = () => {
  const data = [
    {
      count: "",
      label:<>India's Top <b>NAAC A++</b> Universities</> ,
      img: "/assets/images/logo/NAAC.png",
    },
    {
      count: "₹ 2 Cr +",
      label: "Monthly Payout",
      img: "/assets/images/home/counter/img2.png",
    },
    {
      count: "Zero",
      label: "Investment",
      img: "/assets/images/home/counter/img3.png",
    },
    {
      count: "250+",
      label: "Active Partners",
      img: "/assets/images/home/counter/img4.png",
    },
  ];

  return (
    <section className="Counter">
      <div className="container">
        <div className="box_holder">
          <div className="row gx-0">
            {data?.map((item, index) => (
              <div className="col-lg-3 col-md-3 col-sm-6 col-6" key={index}>
                <div className="counter_main_div">
                  <div className="img_holder">
                    <img
                      src={process.env.PUBLIC_URL + item?.img}
                      alt={item?.label}
                      className="iner_img"
                    />
                  </div>
                  <div className="texh_holder">
                    <p className="count_text">{item?.count}</p>
                    <p className="label_text">{item?.label}</p>
                  </div>
                </div>

              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Counter;
